import PropTypes from 'prop-types'

const ResponseToneType = PropTypes.oneOf([
  'bad',
  'good',
  'neutral',
  'notGood',
  'veryBad',
])

export default ResponseToneType
